<div class="plan-content">
    <div class="plan plan-box" *ngFor="let plan of plans">
        <div class="flex-container flex-center max-width plan-box-title">
            <div class="flex-container direction-column align-items">
                <h6 class="plan-title">{{plan.title}}</h6>
                <div class="plan-box-divider"></div>
            </div>
        </div>
        <div class="plan-table">
            <div class="plant-row plant-heading">
                <div class="plant-cell col-{{cell.colSpan??0}}" *ngFor="let cell of plan.table.columns"
                    [ngClass]="{'bold':cell.bold}">
                    <ng-container [ngTemplateOutlet]="cellTemplate" [ngTemplateOutletContext]="{ $implicit: cell }">
                    </ng-container>
                </div>
            </div>
            <div class="plant-row" *ngFor="let row of plan.table.rows">
                <div class="plant-cell  col-{{cell.colSpan??0}}" *ngFor="let cell of row.cells"
                    [ngClass]="{'bold':cell.bold}">
                    <ng-container [ngTemplateOutlet]="cellTemplate" [ngTemplateOutletContext]="{ $implicit: cell }">
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
</div>
<ng-template #cellTemplate let-cell>
    <div [ngSwitch]="cell.type">
        <span *ngSwitchCase="'text'" translate>{{cell.value}}</span>

        <span *ngSwitchCase="'$'" translate>{{cell.value}}$</span>
        <span *ngSwitchCase="'number'" translate>{{cell.value}}</span>
        <div *ngSwitchCase="'link'" class="button">
            <a href="{{cell.href}}" target="_blank" class="mark-button button-cut" translate>{{cell.value}}</a>
        </div>
        <div *ngSwitchCase="'subscribe'" class="button">
            <a href="{{cell.value}}" class="mark-button button-cut" translate>subscribe</a>
        </div>
        <span *ngSwitchDefault></span>
    </div>
</ng-template>